import React from 'react';
import { personalInfo, experience, skills, philosophy } from '../mockData';
import { MapPin, Briefcase, GraduationCap } from 'lucide-react';
import SkillCard from '../components/SkillCard';

const About = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-24 pb-16 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-16">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">About Me</h1>
          <p className="text-xl text-neutral-400 leading-relaxed">
            {personalInfo.description}
          </p>
        </div>

        {/* Location */}
        <div className="flex items-center gap-2 text-neutral-400 mb-16">
          <MapPin size={20} className="text-cyan-400" />
          <span>Based in {personalInfo.location}</span>
          <span className="text-neutral-700">·</span>
          <span>Originally from {personalInfo.origin}</span>
        </div>

        {/* Philosophy */}
        <section className="mb-20">
          <h2 className="text-3xl font-bold mb-6">Philosophy</h2>
          <p className="text-lg text-neutral-300 leading-relaxed mb-8">
            {philosophy.statement}
          </p>

          <div className="space-y-6">
            {philosophy.principles.map((principle, index) => (
              <div key={index} className="border-l-2 border-cyan-500 pl-6 py-2">
                <h3 className="text-lg font-semibold text-white mb-2">{principle.title}</h3>
                <p className="text-neutral-400">{principle.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Experience Timeline */}
        <section className="mb-20">
          <h2 className="text-3xl font-bold mb-8">Experience</h2>
          <div className="space-y-8">
            {experience.map((exp, index) => (
              <div key={exp.id} className="relative pl-8 border-l border-neutral-800">
                <div className="absolute left-[-9px] top-0 w-4 h-4 rounded-full bg-cyan-500 border-4 border-black" />
                
                <div className="bg-neutral-900/50 border border-neutral-800 rounded-lg p-6">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h3 className="text-xl font-semibold text-white">{exp.role}</h3>
                      <p className="text-cyan-400 font-medium">{exp.company}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm text-neutral-400">{exp.duration}</p>
                      <p className="text-sm text-neutral-500">{exp.location}</p>
                    </div>
                  </div>
                  
                  <p className="text-neutral-300 mb-4">{exp.description}</p>
                  
                  <ul className="space-y-2">
                    {exp.achievements.map((achievement, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-neutral-400">
                        <span className="text-cyan-400 mt-1">•</span>
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Skills Grid */}
        <section>
          <h2 className="text-3xl font-bold mb-8">Technical Skills</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {skills.map((skill) => (
              <SkillCard key={skill.id} skill={skill} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
